import * as api from '../api';

const fetchCurrentTenantActions = api.fetchActions('tenant', 'fetch-current-tenant');

export const actionTypes = {
  ...fetchCurrentTenantActions.actionTypes
};

export const getCurrentTenantFromSlug = (slug) => api.getThunk(`/tenantInfo/${slug}`, null, fetchCurrentTenantActions);




// WEBPACK FOOTER //
// src/tenantInfo/tenant.actions.js